// extracted by mini-css-extract-plugin
export default {"ValuesBlock":"Display_ValuesBlock__LB8XF","Value":"Display_Value__jka8m"};